module.exports = __webpack_public_path__ + "static/media/19.f329f8e5.png";